export const RootRoutes = {
	auth: '/auth',
	profile: '/admin/dashboard',
	stylesExamples: '/styles-examples',
};

export const StylesExamplesRoutes = {
	root: RootRoutes.stylesExamples,
	page: 'page',
};
